
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as errormwD7kY_45BU1_rHGEshIkO6bNB5B0luZiwF4k9TLpjX_45IMeta } from "/app/pages/error.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta } from "/app/pages/search.vue?macro=true";
import { default as my_45cart7y6fpXlqmlORSvj3d5M2auTKohd9w3poo_45mO3ltj9Z8Meta } from "/app/pages/my-cart.vue?macro=true";
import { default as checkoutrJOJ_qEKslhH7u_45okx_45tCaYkZe6jupNB2VSAVuoHgEMMeta } from "/app/pages/checkout.vue?macro=true";
import { default as _91id_93ojZA8VK_450taLo_45Dg8jrcCn5LIVCS0S2PeDRaKCQcA_45YMeta } from "/app/pages/flyer/[id].vue?macro=true";
import { default as device_45infovpcL7kOsKOj6_45ro94oBDQ_458c4xzrfbpJVsxA82n1ZakMeta } from "/app/pages/device-info.vue?macro=true";
import { default as index2PYMTDJrpLuKw87XcSdwT4b4Wne8Fi8XVnZfQYbjf_AMeta } from "/app/pages/brands/index.vue?macro=true";
import { default as _91id_93v15slvlvNAxNNuHchmMPm0LvNxqcQdVMh7sJho0kZtIMeta } from "/app/pages/product/[id].vue?macro=true";
import { default as shoppingcartrFH7gvh8XtBRhEs1AdDAgqEf2013SkC4ARwh5MHZTxMMeta } from "/app/pages/shoppingcart.vue?macro=true";
import { default as _91id_93iX5VV4f6GD6AcdhmvTqhN4ce37Rvo8HCR0whlGBzeF0Meta } from "/app/pages/category/[id].vue?macro=true";
import { default as account_45verifyVLYAeIPOLlFC1f6Q7G8LxZ5zlV3au4elXKNgDg77OE4Meta } from "/app/pages/account-verify.vue?macro=true";
import { default as signinwRuZa2Rz_GqJzARqwsC3Pdr8Pjo0MUnXiKCgITxD9B4Meta } from "/app/pages/account/signin.vue?macro=true";
import { default as signupuRW9PNaz3_45i_KbfLoq3_45T7z2lB_45asw36NM8__9YEJrYMeta } from "/app/pages/account/signup.vue?macro=true";
import { default as privacy_45policyzgG_45S68_451GHrVnCshLKLsmg43yjC4fB7Q3UU1pkWXTMMeta } from "/app/pages/privacy-policy.vue?macro=true";
import { default as register_45status6WlznQnN3A0oFJND0o7FDudmB57PFD1AefRkcPzSZRQMeta } from "/app/pages/register-status.vue?macro=true";
import { default as profilel8QJqZHWlEIEzv_lMrfO_uaBYAFRK8oa66If34E_45cRgMeta } from "/app/pages/my-account/profile.vue?macro=true";
import { default as indexFN4FXYMexRdaERcC7zWt493HmaIMw7sz5WrkdCqgZpAMeta } from "/app/pages/new-arrivals/index.vue?macro=true";
import { default as indexKzM7vcCBJwGrVMqUF_45d7R36brHqo5YrZdxkvw0RZg4oMeta } from "/app/pages/preview-file/index.vue?macro=true";
import { default as _91id_939AcFRaOgkGldwqGG4Z0a9ry2ORlp_68NkmG6ggdvhtEMeta } from "/app/pages/activity/theme/[id].vue?macro=true";
import { default as listy4MrrPNFs136jySNp0usildMCn48JAoaFatOLypmC7IMeta } from "/app/pages/activity/theme/list.vue?macro=true";
import { default as _91id_93C4k_Pzb15YizxLuPDcBqQnoGPatZS2oiMubCypt6XE0Meta } from "/app/pages/artwork-design/[id].vue?macro=true";
import { default as trackingaEYgLoqsWX3dnFaC5AS_45KI2pj9hDFlXBYzmWqYURUKEMeta } from "/app/pages/my-account/tracking.vue?macro=true";
import { default as contactusRtBGjo_AnaHGyb9b6pI1kWHBvS1Ek_oKvIRY_qtl2o0Meta } from "/app/pages/my-account/contactus.vue?macro=true";
import { default as terms_45and_45conditionsRU14D3TdeoevONy87DoGrbDHcLlYVbN3gK81tRUROX4Meta } from "/app/pages/terms-and-conditions.vue?macro=true";
import { default as optionscKZ_45EJyWx0QnPZBKX_45QgZmBxBdvQgkg0xeCXgrC1_45x4Meta } from "/app/pages/activity/theme/options.js?macro=true";
import { default as helpknrK2_45mtOv_O8qrb_45k7mZ17EO4eLU_45JYVdj7oaosGKcMeta } from "/app/pages/my-account/orders/help.js?macro=true";
import { default as reset_45passwordbIUHVkiEAKIKwOPjDg4R625qseb7cYzSO1Q7EbJqoOUMeta } from "/app/pages/account/reset-password.vue?macro=true";
import { default as category_45listsFwHOJ_g7iVcqpbjSX_45mA1ytE60UmBpKuCERs8TeRNMMeta } from "/app/pages/category/category-list.vue?macro=true";
import { default as _91id_93TzYBolcJoqR9h4z14gLOONHTIyUOqyeIlBAlnIAlC3UMeta } from "/app/pages/my-account/orders/[id].vue?macro=true";
import { default as forgot_45passwordnbxO0DcmpZci_9r6lvxwZrT3pPKkpzIp3csL_45wY79hUMeta } from "/app/pages/account/forgot-password.vue?macro=true";
import { default as _91id_939hLSyXH6rBS054_45gj1XBYb8nd1Jotgfpc8BGhYpaAN0Meta } from "/app/pages/activity/clearance/[id].vue?macro=true";
import { default as index_qkDpVrjTT74Dqebsw1kGA_45rY_456P0E4YbcqZKf2tFAgMeta } from "/app/pages/featured-products/index.vue?macro=true";
import { default as indexha9AaySn6xI5uw_OTYMwboUWmf9GQEAbo7mAnRx2pFsMeta } from "/app/pages/my-account/orders/index.vue?macro=true";
import { default as category_45search4EJuZS_45XvilkTZ_45jHzsVxoI2ntD4ubVxyDta5rM94_EMeta } from "/app/pages/category/category-search.vue?macro=true";
import { default as order_45trackingqABYnPLd1kJ7um0_45GHZghZ5NLI_WIQwCmQg0B_5jXfwMeta } from "/app/pages/my-account/order-tracking.vue?macro=true";
import { default as browsing_45historyj55WWT_45xmDho29AWgjnLQO2YpvTd3s1vr8GUDm_45RwCsMeta } from "/app/pages/my-account/browsing-history.vue?macro=true";
export default [
  {
    name: "error",
    path: "/error",
    component: () => import("/app/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta || {},
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "my-cart",
    path: "/my-cart",
    component: () => import("/app/pages/my-cart.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/app/pages/checkout.vue")
  },
  {
    name: "flyer-id",
    path: "/flyer/:id()",
    meta: _91id_93ojZA8VK_450taLo_45Dg8jrcCn5LIVCS0S2PeDRaKCQcA_45YMeta || {},
    component: () => import("/app/pages/flyer/[id].vue")
  },
  {
    name: "device-info",
    path: "/device-info",
    meta: device_45infovpcL7kOsKOj6_45ro94oBDQ_458c4xzrfbpJVsxA82n1ZakMeta || {},
    component: () => import("/app/pages/device-info.vue")
  },
  {
    name: "brands",
    path: "/brands",
    component: () => import("/app/pages/brands/index.vue")
  },
  {
    name: "product-id",
    path: "/product/:id()",
    component: () => import("/app/pages/product/[id].vue")
  },
  {
    name: "shoppingcart",
    path: "/shoppingcart",
    component: () => import("/app/pages/shoppingcart.vue")
  },
  {
    name: "category-id",
    path: "/category/:id()",
    component: () => import("/app/pages/category/[id].vue")
  },
  {
    name: "account-verify",
    path: "/account-verify",
    meta: account_45verifyVLYAeIPOLlFC1f6Q7G8LxZ5zlV3au4elXKNgDg77OE4Meta || {},
    component: () => import("/app/pages/account-verify.vue")
  },
  {
    name: "account-signin",
    path: "/account/signin",
    meta: signinwRuZa2Rz_GqJzARqwsC3Pdr8Pjo0MUnXiKCgITxD9B4Meta || {},
    component: () => import("/app/pages/account/signin.vue")
  },
  {
    name: "account-signup",
    path: "/account/signup",
    meta: signupuRW9PNaz3_45i_KbfLoq3_45T7z2lB_45asw36NM8__9YEJrYMeta || {},
    component: () => import("/app/pages/account/signup.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: "register-status",
    path: "/register-status",
    component: () => import("/app/pages/register-status.vue")
  },
  {
    name: "my-account-profile",
    path: "/my-account/profile",
    component: () => import("/app/pages/my-account/profile.vue")
  },
  {
    name: "new-arrivals",
    path: "/new-arrivals",
    component: () => import("/app/pages/new-arrivals/index.vue")
  },
  {
    name: "preview-file",
    path: "/preview-file",
    meta: indexKzM7vcCBJwGrVMqUF_45d7R36brHqo5YrZdxkvw0RZg4oMeta || {},
    component: () => import("/app/pages/preview-file/index.vue")
  },
  {
    name: "activity-theme-id",
    path: "/activity/theme/:id()",
    component: () => import("/app/pages/activity/theme/[id].vue")
  },
  {
    name: "activity-theme-list",
    path: "/activity/theme/list",
    component: () => import("/app/pages/activity/theme/list.vue")
  },
  {
    name: "artwork-design-id",
    path: "/artwork-design/:id()",
    meta: _91id_93C4k_Pzb15YizxLuPDcBqQnoGPatZS2oiMubCypt6XE0Meta || {},
    component: () => import("/app/pages/artwork-design/[id].vue")
  },
  {
    name: "my-account-tracking",
    path: "/my-account/tracking",
    component: () => import("/app/pages/my-account/tracking.vue")
  },
  {
    name: "my-account-contactus",
    path: "/my-account/contactus",
    component: () => import("/app/pages/my-account/contactus.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    component: () => import("/app/pages/terms-and-conditions.vue")
  },
  {
    name: "activity-theme-options",
    path: "/activity/theme/options",
    component: () => import("/app/pages/activity/theme/options.js")
  },
  {
    name: "my-account-orders-help",
    path: "/my-account/orders/help",
    component: () => import("/app/pages/my-account/orders/help.js")
  },
  {
    name: "account-reset-password",
    path: "/account/reset-password",
    meta: reset_45passwordbIUHVkiEAKIKwOPjDg4R625qseb7cYzSO1Q7EbJqoOUMeta || {},
    component: () => import("/app/pages/account/reset-password.vue")
  },
  {
    name: "category-category-list",
    path: "/category/category-list",
    component: () => import("/app/pages/category/category-list.vue")
  },
  {
    name: "my-account-orders-id",
    path: "/my-account/orders/:id()",
    component: () => import("/app/pages/my-account/orders/[id].vue")
  },
  {
    name: "account-forgot-password",
    path: "/account/forgot-password",
    meta: forgot_45passwordnbxO0DcmpZci_9r6lvxwZrT3pPKkpzIp3csL_45wY79hUMeta || {},
    component: () => import("/app/pages/account/forgot-password.vue")
  },
  {
    name: "activity-clearance-id",
    path: "/activity/clearance/:id()",
    component: () => import("/app/pages/activity/clearance/[id].vue")
  },
  {
    name: "featured-products",
    path: "/featured-products",
    component: () => import("/app/pages/featured-products/index.vue")
  },
  {
    name: "my-account-orders",
    path: "/my-account/orders",
    component: () => import("/app/pages/my-account/orders/index.vue")
  },
  {
    name: "category-category-search",
    path: "/category/category-search",
    component: () => import("/app/pages/category/category-search.vue")
  },
  {
    name: "my-account-order-tracking",
    path: "/my-account/order-tracking",
    component: () => import("/app/pages/my-account/order-tracking.vue")
  },
  {
    name: "my-account-browsing-history",
    path: "/my-account/browsing-history",
    component: () => import("/app/pages/my-account/browsing-history.vue")
  }
]